import React, { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Full-screen modal portaled to document.body (above chart, wallet, side menu).
 */
export default function PlatformModal({ onClose, children, boxStyle, boxClassName = "", darkTheme = false }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (typeof document === "undefined") return null;

  const themeClass = darkTheme
    ? "platform-menu-modal-overlay--dark"
    : "platform-menu-modal-overlay--light";

  return createPortal(
    <div
      className={`modal-overlay platform-menu-modal-overlay ${themeClass}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="presentation"
    >
      <div
        className={`modal-box platform-menu-modal-box ${boxClassName}`.trim()}
        style={boxStyle}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
